module.exports = {"id":"225669","name":"Kingsley Ehizibue","rating":"72","photo":"./data/images/photos/3/225669.png","club":{"name":"PEC Zwolle","logo":"./data/images/clubs/PECZwolle.png"},"positions":["DD","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KingsleyEhizibue0.json
// module id = 2387
// module chunks = 0